import React from 'react';
import * as url from 'url';
import 'antd/dist/antd.css';
import {
  Table,
  Input,
  Button,
  Space,
  Dropdown,
  Empty,
  Menu,
  message,
  Tag,
  Divider,
  Tooltip,
} from 'antd';
import Highlighter from 'react-highlight-words';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { SortOrder } from 'antd/es/table/interface';
import moment from 'moment';
import { renderServiceStatus } from '../../utils';
import { Device } from '../../../../contexts/mainContext';
import { SearchServicesQuery } from '../../../../graphql/datamodel.gen';
import ContextMenu from './ContextMenu/ContextMenu';
import { getTableScroll } from '../../../../utils/table';

interface IServicesTableProps {
  services: any[];
  isAdmin: boolean;
  isClient: boolean;
  loading: boolean;
  device: Device;
  searchResult: SearchServicesQuery['searchServices'];
  searchLoading: boolean;
  filteredInfo: any;
  sortedInfo: any;
  showModal: (modal: string, recordId?: string) => void;
  showDriverManagementDrawer: (record: any) => void;
  showPassengerDrawer: (record: any) => void;
  openEditServiceDrawer: (record: any) => void;
  showServiceBriefingDrawer: (record: any, index: any) => void;
  setSortedInfo: (info: any) => any;
  setFilteredInfo: (info: any) => any;
}

class ServicesTable extends React.Component<IServicesTableProps> {
  state = {
    searchText: '',
    searchedColumn: '',
    dropdownActionsVisible: false,
    contextMenuState: {
      record: undefined,
      visible: false,
      x: 0,
      y: 0,
    },
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined translate={undefined} />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ color: filtered ? '#1890ff' : undefined }}
        translate={undefined}
      />
    ),
    onFilter: (value, record) => {
      const searchValue = dataIndex.split('.').reduce(function (a, b) {
        return a[b];
      }, record);

      return searchValue
        ? searchValue.toString().toLowerCase().includes(value.toLowerCase())
        : '';
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    ellipsis: {
      showTitle: false,
    },
    render: (text) => {
      const component =
        this.state.searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        );

      return (
        <Tooltip placement="topLeft" title={text}>
          {component}
        </Tooltip>
      );
    },
  });

  handleChange = (pagination: any, filters: any, sorter: any) => {
    this.props.setSortedInfo(sorter);
    this.props.setFilteredInfo(filters);
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: '' });
  };
  searchInput: Input;

  render() {
    const { device } = this.props;
    // const { selectedRowKeys } = this.state;
    const sortedInfo = this.props.sortedInfo || {};
    // const filteredInfo = this.props.filteredInfo || {};

    const actionColumn = {
      title: 'Acciones',
      key: 'actions',
      width: 155,
      fixed: 'right',
      render: (text: any, record: any, index: any) => {
        const actionsMenu = (
          <Menu>
            <Menu.Item
              onClick={() => {
                const passengers = (record as any).passengers
                  ? (record as any).passengers
                  : [];
                const emailList = passengers
                  .map((passenger: { email: any }) => passenger.email)
                  .join(';');

                if (!passengers.length) {
                  message.info(
                    'Por favor, rellena el campo email con el correo electrónico de los pasajeros',
                    10,
                  );
                }

                const serviceId = record.volcanoServiceId || record.serviceId;

                const redirectLink = url.resolve(
                  process.env.REACT_APP_GRAPHQL_ENDPOINT as string,
                  `/launch_service/${serviceId}`,
                );

                window.open(
                  `mailto:${emailList}?subject=MVIPS Servicio ${serviceId}&body=Hello,%0D%0A%0D%0AYou can check service ${serviceId} info clicking this link ${redirectLink}.%0D%0A%0D%0AHave a pleasant trip,%0D%0A%0D%0AMVIPS Team%0D%0A%0D%0A%0D%0AHola,%0D%0A%0D%0APuede consultar la información del servicio ${serviceId} haciendo click en este link ${redirectLink}.%0D%0A%0D%0ALe deseamos un buen viaje,%0D%0A%0D%0AEl equipo de MVIPS`,
                );
              }}
              key="send_email"
            >
              Enviar email a los pasajeros
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              onClick={() => {
                this.props.showModal(
                  'SERVICE_LINK_APP',
                  record.volcanoServiceId || record.serviceId,
                );
              }}
              key="generate_service_link_app"
            >
              Generar link al servicio (app)
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.props.showModal('PASSENGER_APP_LINK');
              }}
              key="get_passenger_app_link"
            >
              Obtener link app pasajero
            </Menu.Item>
            {/* <Menu.Item
              onClick={() =>
                this.showModal('MOBILE_LINK', record.volcanoServiceId)
              }
              key="generate_mobile_app_link"
            >
              Generar link app móvil
            </Menu.Item> */}
            <Menu.Divider />

            <Menu.Item
              onClick={() => this.props.showDriverManagementDrawer(record)}
              key="manage_drivers"
            >
              Ver conductores
            </Menu.Item>
            <Menu.Item
              onClick={() => this.props.showPassengerDrawer(record)}
              key="manage_passengers"
            >
              Ver pasajeros
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              style={{ color: '#1890ff' }}
              onClick={() => this.props.openEditServiceDrawer(record)}
            >
              Gestionar servicio
            </Menu.Item>
            {/* <Menu.Item
              color={'red'}
              style={{ color: '#f5222d' }}
              onClick={() => this.openCancelServiceModal(record)}
            >
              Anular servicio
            </Menu.Item> */}
          </Menu>
        );
        return (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button
              size="small"
              style={{ paddingRight: '10px' }}
              onClick={() =>
                this.props.showServiceBriefingDrawer(record, index)
              }
            >
              Info
            </Button>
            <span>|</span>
            <Dropdown
              overlay={actionsMenu}
              onVisibleChange={(visible) => {
                this.setState({
                  dropdownActionsVisible: visible,
                });
              }}
            >
              <Button size="small">
                Acciones <DownOutlined translate={undefined} />
              </Button>
            </Dropdown>
          </div>
        );
      },
    };
    const clientColumns = [
      {
        title: 'ID',
        dataIndex: 'volcanoServiceId',
        key: 'id',
        width: 100,
        ...this.getColumnSearchProps('volcanoServiceId'),
      },
      {
        title: 'Estado',
        dataIndex: 'status',
        key: 'status',
        width: 150,
        render: (status: string, record: any) => (
          <span>
            {(() => {
              const { color, text } = renderServiceStatus(record.status);

              return (
                <Tag color={color} key={record.status || 'unknown'}>
                  {text.toUpperCase()}
                </Tag>
              );
            })()}
          </span>
        ),
        filters: [
          {
            text: 'Asignado',
            value: 'assigned',
          },
          {
            text: 'Confirmado',
            value: 'confirmed',
          },
          {
            text: 'Cancelado',
            value: 'canceled',
          },
          {
            text: 'Finalizado',
            value: 'closed',
          },
          {
            text: 'Vehículo en origen',
            value: 'vehicle_on_departure_spot',
          },
          {
            text: 'En marcha',
            value: 'ongoing',
          },
        ],
        // filteredValue: (this.props.filteredInfo as any).status || null,
        onFilter: (filter: string, record: any) => {
          return record.status === filter;
        },
        sorter: (a: any, b: any) => a.status.length - b.status.length,
        sortOrder:
          (sortedInfo as any).columnKey === 'status' &&
          (sortedInfo as any).order,
      },
      {
        title: 'Salida',
        dataIndex: 'departure',
        key: 'departure',
        width: 150,
        sortDirections: ['descend', 'ascend'] as SortOrder[],
        defaultSortOrder: 'descend' as 'descend' | 'ascend' | undefined,
        render: (_: any, record: any) => {
          if (!record.departure) {
            return null;
          }
          return (
            <div>
              {record.departure.date} <b>{record.departure.time}</b>
            </div>
          );
        },
        sorter: (a: any, b: any) => {
          if (
            a.departure &&
            a.departure.time &&
            a.departure.date &&
            b.departure &&
            b.departure.time &&
            b.departure.date
          ) {
            const aDateTime = new Date(a.departure.date);
            aDateTime.setHours(
              Number((a.departure.time as string).split(':')[0]),
              Number((a.departure.time as string).split(':')[1]),
            );

            const bDateTime = new Date(b.departure.date);
            bDateTime.setHours(
              Number((b.departure.time as string).split(':')[0]),
              Number((b.departure.time as string).split(':')[1]),
            );

            return bDateTime.getTime() - aDateTime.getTime();
          }

          return 0;
        },
        sortOrder:
          ((sortedInfo as any).columnKey === 'departure' &&
            (sortedInfo as any).order) ||
          'descend',
      },
      {
        title: 'Llegada',
        dataIndex: 'arrival',
        key: 'arrival',
        width: 75,
        render: (_: any, record: any) => {
          if (!record.arrival || !record.departure) {
            return null;
          }

          const arrivalDate = moment(record.arrival.date);
          const departureDate = moment(record.departure.date);
          const durationAsDays = moment
            .duration(arrivalDate.diff(departureDate))
            .asDays();

          if (durationAsDays >= 1) {
            // Append +1 to the time
            return (
              <div>
                <b>{record.arrival.time}</b> <sup>+{durationAsDays}</sup>
              </div>
            );
          } else {
            // Just show the time
            return (
              <div>
                <b>{record.arrival.time}</b>
              </div>
            );
          }
        },
      },
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
        ellipsis: {
          showTitle: false,
        },
        ...this.getColumnSearchProps('description'),
        onCell: (_: any, rowIndex: any) => {
          return {
            onMouseEnter: () => {
              this.setState({
                showTooltip: {
                  column: 'description',
                  row: rowIndex,
                },
              });
            },
            onMouseLeave: () => {
              this.setState({
                showTooltip: {
                  column: undefined,
                  row: undefined,
                },
              });
            },
          };
        },
      },
      {
        title: 'Referencia',
        key: 'reference',
        width: 200,
        dataIndex: 'reference',
        ellipsis: {
          showTitle: false,
        },
        ...this.getColumnSearchProps('reference'),
      },
    ];
    const adminColumns = [
      ...clientColumns,
      {
        title: 'Presupuesto',
        key: 'budgetReadableId',
        dataIndex: 'budgetReadableId',
        width: 130,
        ...this.getColumnSearchProps('budgetReadableId'),
      },
      {
        title: 'Cliente',
        dataIndex: ['client', 'name'],
        key: 'client.name',
        width: 250,
        ellipsis: true,
        ...this.getColumnSearchProps('client.name'),
      },
    ];

    let selectedColumns = this.props.isAdmin ? adminColumns : clientColumns;
    selectedColumns.push(actionColumn as any);

    const mobileColumns = ['id', 'status', 'departure', 'arrival', 'reference'];

    selectedColumns = selectedColumns.filter((column) => {
      if (!device) return true;
      if (device.type === 'desktop') return true;
      if (device.type === 'phone') {
        return mobileColumns.includes(column.key);
      }
      return true;
    });

    // @ts-ignore
    selectedColumns =
      device.type === 'phone'
        ? selectedColumns.map((selectedColumn) => {
            if (selectedColumn.key === 'reference') {
              return {
                ...selectedColumn,
                title: '#Ref',
                width: undefined,
              };
            }

            return selectedColumn;
          })
        : selectedColumns;

    if (device.type === 'phone') {
      // @ts-ignore
      selectedColumns.push({
        title: '',
        key: 'actions',
        // @ts-ignore
        render: (text: any, record: any, index: any) => {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                // size="default"
                onClick={() =>
                  this.props.showServiceBriefingDrawer(record, index)
                }
              >
                Ver más
              </Button>
            </div>
          );
        },
      });
    }

    const tableProps =
      device.type === 'desktop'
        ? {
            rowSelection: undefined,
            expandedRowRender: (record: any) => (
              <p style={{ margin: 0 }}>
                {(record as any).itinerary_description}
              </p>
            ),
          }
        : { rowSelection: undefined, expandedRowRender: undefined };

    return (
      <>
        <Table
          {...tableProps}
          // sticky
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                event.preventDefault();
                if (this.state.dropdownActionsVisible === false) {
                  this.props.showServiceBriefingDrawer(record, undefined);
                }
              },
              onContextMenu: (event) => {
                event.preventDefault();

                if (this.state.contextMenuState.visible) {
                  return this.setState({
                    contextMenuState: {
                      record: undefined,
                      visible: false,
                      x: 0,
                      y: 0,
                    },
                  });
                }

                if (!this.state.contextMenuState.visible) {
                  const that = this;
                  document.addEventListener(`click`, function onClickOutside() {
                    that.setState({ contextMenuState: { visible: false } });
                    document.removeEventListener(`click`, onClickOutside);
                  });
                }
                this.setState({
                  contextMenuState: {
                    record,
                    visible: true,
                    x: event.clientX,
                    y: event.clientY,
                  },
                });
              },
            };
          }}
          rowKey={(record) => record.id}
          loading={this.props.loading}
          locale={{
            emptyText: (
              <Empty
                description={
                  'No hay servicios en el rango de fechas seleccionado. \n Puedes seleccionar otro rango si lo deseas.'
                }
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ),
          }}
          size={'small'}
          pagination={{ pageSize: 25 }}
          columns={selectedColumns}
          dataSource={
            this.props.searchResult?.length > 0 && !this.props.searchLoading
              ? (this.props.searchResult as any)
              : this.props.services
          }
          onChange={this.handleChange}
          scroll={{ y: getTableScroll() }}
        />
        <ContextMenu {...this.state.contextMenuState}>
          <li
            onClick={() => {
              const passengers = (this.state.contextMenuState.record as any)
                .passengers
                ? (this.state.contextMenuState.record as any).passengers
                : [];
              const emailList = passengers
                .map((passenger: { email: any }) => passenger.email)
                .join(';');

              if (!passengers.length) {
                message.info(
                  'Por favor, rellena el campo email con el correo electrónico de los pasajeros',
                  10,
                );
              }

              const serviceId =
                this.state.contextMenuState.record.volcanoServiceId ||
                this.state.contextMenuState.record.serviceId;

              const redirectLink = url.resolve(
                process.env.REACT_APP_GRAPHQL_ENDPOINT as string,
                `/launch_service/${serviceId}`,
              );

              window.open(
                `mailto:${emailList}?subject=MVIPS Servicio ${serviceId}&body=Hello,%0D%0A%0D%0AYou can check service ${serviceId} info clicking this link ${redirectLink}.%0D%0A%0D%0AHave a pleasant trip,%0D%0A%0D%0AMVIPS Team%0D%0A%0D%0A%0D%0AHola,%0D%0A%0D%0APuede consultar la información del servicio ${serviceId} haciendo click en este link ${redirectLink}.%0D%0A%0D%0ALe deseamos un buen viaje,%0D%0A%0D%0AEl equipo de MVIPS`,
              );
            }}
          >
            Enviar email a los pasajeros
          </li>
          <Divider style={{ marginTop: 3, marginBottom: 3 }} />
          <li
            onClick={() => {
              this.props.showModal(
                'SERVICE_LINK_APP',
                this.state.contextMenuState.record.volcanoServiceId ||
                  this.state.contextMenuState.record.serviceId,
              );
            }}
          >
            Generar link al servicio (app)
          </li>
          <li
            onClick={() => {
              this.props.showModal('PASSENGER_APP_LINK');
            }}
          >
            Obtener link app pasajero
          </li>
          <Divider style={{ marginTop: 3, marginBottom: 3 }} />
          <li
            onClick={() =>
              this.props.showDriverManagementDrawer(
                this.state.contextMenuState.record,
              )
            }
          >
            Ver conductores
          </li>
          <li
            onClick={() =>
              this.props.showPassengerDrawer(this.state.contextMenuState.record)
            }
          >
            Ver pasajeros
          </li>
          <Divider style={{ marginTop: 3, marginBottom: 3 }} />
          <li
            style={{ color: '#1890ff' }}
            onClick={() =>
              this.props.openEditServiceDrawer(
                this.state.contextMenuState.record,
              )
            }
          >
            Gestionar servicio
          </li>
          {/* <li
        style={{ color: '#f5222d' }}
        onClick={() =>
          this.openCancelServiceModal(this.state.contextMenuState.record)
        }
      >
        Anular servicio
      </li> */}
        </ContextMenu>
      </>
    );
  }
}

export default ServicesTable;
